import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-line-chart',
	templateUrl:'./AgLineChartPluginCompPage.html',
	styles: [],
	styleUrls:['./AgLineChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgLineChartPluginCompPage
{
	mdContent_743 = `\`\`\`java
import com.jwebmp.plugins.agcharts.AgLineChart;
\`\`\``;
	mdContent_744 = `\`\`\`java
AgLineChart(String id, String xKey, String yKey)
\`\`\``;
}
